<template>
  <div
    class="index-container all-box"
    ref="mainContainer"
    v-loading="isLoading"
  >
    <div class="personal-wrap">
      <picture class="banner-picture">
        <source srcset="@/assets/banner.webp" type="image/webp" />
        <img src="@/assets/banner.png" alt="活动 banner" class="banner-container" />
      </picture>

      <div class="person-nav-bg">
        <div class="person-info">
          <el-row :align="'middle'" style="width: 100%">
            <el-col :span="14" class="person-all-wrap">
              <el-avatar
                :size="50"
                shape="square"
                :src="
                  storage.getItem('headimgurl')
                    ? 'https://clubs.xinmin.cn/' + storage.getItem('headimgurl')
                    : 'https://clubs.xinmin.cn/' + wx.headimgurl
                "
                :fit="fits[2]"
                @error="errorHandler"
                class="person-author"
              >
                <img src="@/assets/author.png" style="object-fit: contain" />
              </el-avatar>
              <div class="person-name">
                <p class="pname">
                  {{ displayNickname }}
                </p>
                <div class="person-equity-icon">
                  <el-text>{{ vipText }}</el-text>
                </div>
              </div>
            </el-col>
            <el-col :span="10" class="person-all-wrap">
              <div class="person-jifen-container">
                <div class="person-qiandao-container" @click="handleQiandao">
                  <img
                    src="@/assets/qiandao.png"
                    alt=""
                    class="qiandao"
                    v-if="!qiandao"
                  />
                  <img
                    src="@/assets/onqiandao.png"
                    alt=""
                    class="qiandao"
                    v-else
                  />
                </div>
                <div class="person-jifen-items">
                  <p class="person-items-text">我的积分</p>
                  <p class="person-num">{{ jifen ? jifen : 0 }}</p>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="person-display-wrap">
          <el-row
            justify="space-between"
            :align="'middle'"
            class="person-display-title"
          >
            <el-col :span="12"><h2></h2></el-col>
            <el-col :span="12"><p></p></el-col>
          </el-row>
          <el-row class="person-display-item">
            <el-col :span="24" class="person-items">
              <div class="person-item-link" @click="handleActiveCodeClick">
                <div class="choose-left-container">
                  <KyIcon
                    type="xinmin"
                    size="22"
                    color="#D70C18"
                    class="person-items-icon"
                  />
                  <p class="person-items-text">读者会员激活码</p>
                </div>

                <KyIcon
                  type="back"
                  size="16"
                  color="#444"
                  class="person-items-icon-back"
                />
              </div>
            </el-col>
            <el-col
              :span="item.blockSpan"
              class="person-items"
              v-for="(item, key) in itemViews"
              :key="key"
            >
              <component
                :is="item.linkType === 'external' ? 'a' : 'router-link'"
                v-bind="getLinkProps(item)"
                class="person-item-link"
              >
                <div class="choose-left-container">
                  <KyIcon
                    :type="item.icon.type"
                    :size="item.icon.size"
                    :color="item.icon.color"
                    class="person-items-icon"
                  />
                  <p class="person-items-text">{{ item.title }}</p>
                </div>

                <KyIcon
                  type="back"
                  size="16"
                  color="#444"
                  class="person-items-icon-back"
                />
              </component>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="allDialog">
      <el-dialog
        title="读者会员激活码"
        v-model="showDialog"
        width="70%"
        top="36vh"
        :show-close="false"
        center
        destroy-on-close
      >
        <div>
          <el-input
            placeholder="请填写八位号码"
            v-model="jihuoma_code"
            maxlength="8"
          />
        </div>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="showDialog = false">取 消</el-button>
            <el-button @click="confirmUsechange" style="color: #ee5f5c"
              >确认兑换</el-button
            >
          </div>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import fetchData from "@/mixins/fetchData.js";
import mainScroll from "@/mixins/mainScroll.js";
import { getUserInfo } from "@/api/home.js";
import { jihuoCode } from "@/api/user.js";
import Footer from "@/components/util/Footer";
import KyIcon from "@/components/KyIcon";
import MyActive from "@/views/Active/MyActive";

export default {
  components: {
    Footer,
    MyActive,
    KyIcon,
  },
  mixins: [fetchData({}), mainScroll("mainContainer")],
  data() {
    return {
      storage: window.localStorage,
      fits: ["fill", "contain", "cover", "none", "scale-down"],
      wx: {
        uid: 0,
        openid: "",
        nickname: "新民晚报",
        headimgurl: "",
        userToken: "",
      },
      showDialog: false,
      jihuoma_code: "",
      jifen: 0,
      isMsg: false,
      new_vip: 0,
      qiandao: false,
      itemViews: [
        {
          blockSpan: 24,
          title: "我的报名",
          routerLink: "MyActive",
          icon: {
            type: "myActive",
            color: "#444",
            size: "22",
          },
        },
        {
          blockSpan: 24,
          title: "关注服务号",
          routerLink:
            "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzk0MzU2NzYwMQ==#wechat_redirect",
          linkType: "external",
          icon: {
            type: "fuwuhao",
            color: "#18c515",
            size: "22",
          },
        },
        {
          blockSpan: 24,
          title: "晚报历年订阅地址",
          routerLink: "AddressHistory",
          icon: {
            type: "location",
            color: "#444",
            size: "22",
          },
        },
        {
          blockSpan: 24,
          title: "设置",
          routerLink: "UserInfo",
          icon: {
            type: "shezhi",
            color: "#444",
            size: "22",
          },
        },
      ],
    };
  },
  methods: {
    errorHandler() {
      return true;
    },
    async fetchData() {
      const resp = await getUserInfo(
        this.storage.getItem("uid"),
        this.storage.getItem("usertoken")
      );
      if (resp) {
        this.wx.nickname = resp.userinfo.nickname;
        this.wx.headimgurl = resp.userinfo.avatar;
        this.jifen = resp.userinfo.jifen;
        this.new_vip = resp.userinfo.new_vip;
        this.qiandao = resp.userinfo.qiandao;
      }
    },
    handleActiveCodeClick() {
      this.jihuoma_code = "";
      this.showDialog = true;
    },
    async confirmUsechange() {
      const uid = this.storage.getItem("uid");
      const usertoken = this.storage.getItem("usertoken");

      if (!this.jihuoma_code.trim()) {
        this.$message.warning({
          message: "请输入激活码",
          type: "warning",
          center: true,
          offset: 90,
          duration: 1500,
          customClass: "message-class",
        });
        return;
      }

      try {
        const dingyueResp = await jihuoCode(uid, usertoken, this.jihuoma_code);

        if (dingyueResp.status) {
          this.showDialog = false;
          this.$message.success({
            message: dingyueResp.message,
            type: "success",
            center: true,
            offset: 90,
            duration: 1500,
            customClass: "message-class",
            onClose: async () => {
              try {
                const resp = await getUserInfo(uid, usertoken);

                if (resp && resp.userinfo) {
                  this.jifen = resp.userinfo.jifen;
                  this.new_vip = resp.userinfo.new_vip;
                } else {
                  this.$message.warning("用户信息刷新失败，请稍后重试");
                }
              } catch (err) {
                console.error("刷新用户信息接口出错:", err);
                this.$message.error("网络错误，用户信息未更新");
              }
            },
          });
        } else {
          this.$message.warning({
            message: dingyueResp.message,
            type: "warning",
            center: true,
            offset: 90,
            duration: 1500,
            customClass: "message-class",
          });
        }
      } catch (err) {
        console.error("激活码接口调用失败:", err);
        this.$message.error({
          message: "网络错误，请稍后重试",
          type: "error",
          center: true,
          offset: 90,
          duration: 1500,
          customClass: "message-class",
        });
      }
    },
    handleQiandao() {
      this.$message.info("签到服务已迁至小程序，请前往小程序签到");
      this.$router.push({
        name: "AppShow",
        query: { service: "Sign" },
      });
    },
    getLinkProps(item) {
      const usertoken = this.storage.getItem("usertoken");
      const props = {};

      // 处理外部链接
      if (item.linkType === "external") {
        const baseUrl = item.link || item.routerLink || "#";
        if (item.dingyue && usertoken) {
          const separator = baseUrl.includes("?") ? "&" : "?";
          props.href = `${baseUrl}${separator}accesstoken=${encodeURIComponent(
            usertoken
          )}`;
        } else {
          props.href = baseUrl;
        }
        props.target = "_blank";
        props.rel = "noopener noreferrer";
        return props;
      }

      const link = item.link || item.routerLink;
      if (!link) {
        console.warn("路由链接为空", item);
        return props;
      }

      if (link.includes(":")) {
        const [routeName, paramsStr] = link.split(":", 2);
        if (!routeName || !paramsStr) {
          console.warn("动态路由格式错误", link);
          props.to = { name: link };
          return props;
        }

        const params = {};
        paramsStr.split("&").forEach((param) => {
          const [key, value] = param.split("=", 2);
          if (key && value !== undefined) {
            params[key] = decodeURIComponent(value);
          }
        });

        props.to = { name: routeName, params };
      } else {
        props.to = { name: link };
      }

      return props;
    },
  },
  computed: {
    vipText() {
      return this.new_vip <= 0 ? "新晋会员" : "VIP会员";
    },
    displayNickname() {
      const storedNickname = this.storage.getItem("nickname");

      if (storedNickname) {
        return decodeURI(storedNickname);
      }

      return this.wx.nickname;
    },
  },
};
</script>

<style scoped lang="less">
.index-container {
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-behavior: smooth;
}

.personal-wrap {
  background-color: var(--fff);
  margin-bottom: 10px;
  color: var(--000);
}

.person-info {
  display: flex;
  margin: auto;
  width: 90%;
  align-items: center;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 12;
  top: -25%;
}

.banner-container {
  display: block;
  width: 100%;
}

.banner-picture {
  display: block;
  width: 100%;
}

.person-all-wrap {
  display: flex;
  align-items: center;
  margin: 3vw auto 0;
}

.person-info .person-name {
  margin-left: 10px;
  text-align: left;
  overflow: hidden;
  flex: 1;
}

.person-info .person-name .pname {
  font-size: 16px;
  margin: 0;
  padding-bottom: 5px;
  color: var(--fff);
  font-weight: 600;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.person-info .person-equity-icon span {
  margin-right: 5px;
  color: #fff;
}

.person-nav-bg {
  position: relative;
  z-index: 10;
  width: 100%;
  padding-top: 10px;
  margin-top: -20px;
  border-radius: 15px 15px 0 0;
  background-color: #f5f5f5;
}

.person-display-wrap {
  position: relative;
  width: 90%;
  margin: 10px auto;
  border-radius: 5px;
  overflow: hidden;
  background-color: var(--fff);
  box-shadow: 0 3px 4px rgba(0, 0, 0, 0.1);
}

.person-display-title {
  width: 94%;
  margin: auto;
}

.person-display-title h2 {
  font-size: 18px;
  text-align: left;
}

.person-author {
  border: 1px solid #fff;
}

.person-display-title p {
  font-size: 14px;
  text-align: right;
  color: var(--c1);
}

.person-display-item {
  width: 90%;
  margin: auto;
}

.person-display-item .person-items {
  margin: 15px auto;
}

.person-items-text {
  color: #222;
  font-size: 16px;
  line-height: 1;
}

.choose-left-container {
  display: flex;
  align-items: center;
  gap: 5px;
}

.person-item-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.person-items-icon-back {
  transform: rotate(180deg);
}

.person-jifen-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 5px;
  margin-left: auto;
  .person-qiandao-container {
    width: 60px;
    .qiandao {
      display: block;
      width: 100%;
    }
  }
  .person-jifen-items {
    display: flex;
    align-items: center;
    gap: 5px;
    .person-items-text {
      color: #fff;
      font-size: 14px;
      font-weight: 600;
    }
    .person-num {
      font-size: 14px;
      font-weight: 600;
      color: #fff;
    }
  }
}
</style>
